import Dexie from "dexie";
const NAME = "snort-system";
const VERSION = 3;
const STORES = {
    users: "++pubkey, name, display_name, picture, nip05, npub",
    relayMetrics: "++addr",
    userRelays: "++pubkey",
    contacts: "++pubkey",
    events: "++id, pubkey, created_at",
};
export class SnortSystemDb extends Dexie {
    ready = false;
    users;
    relayMetrics;
    userRelays;
    events;
    contacts;
    constructor() {
        super(NAME);
        this.version(VERSION).stores(STORES);
    }
    isAvailable() {
        if ("indexedDB" in window) {
            return new Promise(resolve => {
                const req = window.indexedDB.open("dummy", 1);
                req.onsuccess = () => {
                    resolve(true);
                };
                req.onerror = () => {
                    resolve(false);
                };
            });
        }
        return Promise.resolve(false);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxLQUFnQixNQUFNLE9BQU8sQ0FBQztBQUVyQyxNQUFNLElBQUksR0FBRyxjQUFjLENBQUM7QUFDNUIsTUFBTSxPQUFPLEdBQUcsQ0FBQyxDQUFDO0FBRWxCLE1BQU0sTUFBTSxHQUFHO0lBQ2IsS0FBSyxFQUFFLG9EQUFvRDtJQUMzRCxZQUFZLEVBQUUsUUFBUTtJQUN0QixVQUFVLEVBQUUsVUFBVTtJQUN0QixRQUFRLEVBQUUsVUFBVTtJQUNwQixNQUFNLEVBQUUsMEJBQTBCO0NBQ25DLENBQUM7QUFFRixNQUFNLE9BQU8sYUFBYyxTQUFRLEtBQUs7SUFDdEMsS0FBSyxHQUFHLEtBQUssQ0FBQztJQUNkLEtBQUssQ0FBeUI7SUFDOUIsWUFBWSxDQUF1QjtJQUNuQyxVQUFVLENBQXNCO0lBQ2hDLE1BQU0sQ0FBcUI7SUFDM0IsUUFBUSxDQUF1QjtJQUUvQjtRQUNFLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQztRQUNaLElBQUksQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFDLENBQUMsTUFBTSxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQ3ZDLENBQUM7SUFFRCxXQUFXO1FBQ1QsSUFBSSxXQUFXLElBQUksTUFBTSxFQUFFO1lBQ3pCLE9BQU8sSUFBSSxPQUFPLENBQVUsT0FBTyxDQUFDLEVBQUU7Z0JBQ3BDLE1BQU0sR0FBRyxHQUFHLE1BQU0sQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLE9BQU8sRUFBRSxDQUFDLENBQUMsQ0FBQztnQkFDOUMsR0FBRyxDQUFDLFNBQVMsR0FBRyxHQUFHLEVBQUU7b0JBQ25CLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQztnQkFDaEIsQ0FBQyxDQUFDO2dCQUNGLEdBQUcsQ0FBQyxPQUFPLEdBQUcsR0FBRyxFQUFFO29CQUNqQixPQUFPLENBQUMsS0FBSyxDQUFDLENBQUM7Z0JBQ2pCLENBQUMsQ0FBQztZQUNKLENBQUMsQ0FBQyxDQUFDO1NBQ0o7UUFDRCxPQUFPLE9BQU8sQ0FBQyxPQUFPLENBQUMsS0FBSyxDQUFDLENBQUM7SUFDaEMsQ0FBQztDQUNGIn0=